export default {
  items: [],
  pagination: {},
  isBusy: false,
  size: 15,
  filters: {
    base: null,
  },
};
